<script>
import { Pie, mixins } from "vue-chartjs";
import chartMixins from "./chartMixin";

const { reactiveProp } = mixins;
export default {
	extends: Pie,
	mixins: [chartMixins, reactiveProp],
	props: {},
	computed: {
		options() {
			return {
				legend: {
					position: "bottom",
					labels: {
						fontSize: 13
					}
				},
				layout: {
					padding: {
						left: 50,
						right: 0,
						top: 0,
						bottom: 0
					}
				},
				tooltips: {
					enabled: this.showTooltip
				}
			};
		}
	},
	mounted() {
		this.renderChart(this.chartData, this.options);
	}
};
</script>
